import React from 'react';
import { BudgetCategory, Condition } from '../types/budget';
import { FlagIcon } from 'lucide-react';
interface CategorySidebarProps {
  categories: BudgetCategory[];
  selectedId: string;
  onSelect: (id: string) => void;
  conditions: Condition[];
}
export function CategorySidebar({
  categories,
  selectedId,
  onSelect,
  conditions
}: CategorySidebarProps) {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  return <div className="w-[280px] bg-white border-r border-gray-200 flex flex-col h-full shrink-0 z-0" data-id="element-35">
      <div className="p-5 border-b border-gray-100 bg-gray-50/30" data-id="element-36">
        <h2 className="text-xs font-heading font-medium text-gray-500 uppercase tracking-widest" data-id="element-37">
          Budget Categories
        </h2>
      </div>

      <div className="flex-1 overflow-y-auto py-2" data-id="element-38">
        {categories.map(cat => {
        const isSelected = cat.id === selectedId;
        const catConditions = conditions.filter(c => c.categoryId === cat.id);
        const hasConditions = catConditions.length > 0;
        const cleanName = cat.name.replace(/^TOTAL\s+/i, '');
        return <button key={cat.id} onClick={() => onSelect(cat.id)} className={`w-full text-left px-5 py-3.5 flex items-center justify-between transition-colors border-l-4 ${isSelected ? 'bg-accent/5 border-accent' : 'border-transparent hover:bg-gray-50'}`} data-id="element-39">
              <div className="flex items-center gap-2 overflow-hidden pr-2" data-id="element-40">
                <span className={`text-sm font-body truncate ${isSelected ? 'font-medium text-primary' : 'font-normal text-gray-700'}`} data-id="element-41">
                  {cleanName}
                </span>
                {hasConditions && <span className="w-2 h-2 rounded-full bg-accent-1 shrink-0 shadow-sm" data-id="element-42" />}
              </div>
              <span className={`text-xs font-body shrink-0 ${isSelected ? 'font-medium text-primary' : 'font-normal text-gray-400'}`} data-id="element-43">
                {formatCurrency(cat.totalBudget)}
              </span>
            </button>;
      })}
      </div>

      <div className="p-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between text-sm font-body font-normal text-gray-600" data-id="element-44">
        <div className="flex items-center gap-2" data-id="element-45">
          <FlagIcon className="w-4 h-4 text-accent-1" data-id="element-46" />
          <span data-id="element-47">Total Conditions</span>
        </div>
        <span className="font-medium text-primary bg-white px-2 py-0.5 rounded border border-gray-200 shadow-sm" data-id="element-48">
          {conditions.length}
        </span>
      </div>
    </div>;
}